import { useMemo } from "react"
import { useAccessToken } from "./useAccessToken"

/**
 * @template T
 * @typedef {<T>(token: string, origin: string) => T} ApiFactory
 *  */

/**
 * @template T
 * @param {ApiFactory<T>} apiFactory
 * @returns {T}
 */
export const useApi = (apiFactory) => {
  const { accessToken, isAuthenticated } = useAccessToken()

  return useMemo(
    () => (accessToken && isAuthenticated ? apiFactory(accessToken) : null),
    [accessToken, apiFactory, isAuthenticated]
  )
}
